var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":"","dense":""}},[_c('v-spacer'),_c('v-toolbar-title',[_vm._v("ADMIN PORTAL")]),_c('v-spacer')],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }